const calculateStandardDeviation  = (data) =>{
    const mean = data.reduce((sum, value) => sum + value, 0) / data.length;
    const squaredDifferences = data.map(value => Math.pow(value - mean, 2));
    const meanOfSquaredDifferences = squaredDifferences.reduce((sum, value) => sum + value, 0) / squaredDifferences.length;  
    const standardDeviation = Math.sqrt(meanOfSquaredDifferences);
    return Math.trunc(standardDeviation);
}

export { calculateStandardDeviation }
  